/* src/app/system-utils/form-item-component/form-item-component.component.scss */
.array-box {
  display: flex;
  height: 100%;
  flex-direction: column;
  border-radius: var(--tem-radius);
  border: 1px solid var(--tem-border);
  background: var(--tem-surface);
  padding: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  overflow: auto;
  font-family: var(--tem-font-family);
}
.tool-field {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.title-field {
  color: var(--tem-ink);
}
.full {
  width: 100%;
}
.form-array {
  display: flex;
  flex-direction: row;
  height: 100%;
  overflow: auto;
  gap: 10px;
  padding-right: 4px;
}
.display-filegroup-item-components {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  overflow: auto;
  padding-top: 10px;
  padding-right: 10px;
}
.display-filegroup-item-components-lines {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.suffix-icon {
  cursor: pointer;
  color: var(--tem-muted);
}
.suffix-icon:hover {
  color: var(--tem-ink);
}
.toggle-line {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  color: var(--tem-ink);
}
:host {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.action-buttons {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-right: 5px;
  padding-left: 10px;
  gap: 10px;
  align-items: flex-end;
  justify-content: center;
  border-left: 1px solid var(--tem-border);
}
/*# sourceMappingURL=form-item-component.component.css.map */
